module.exports = __webpack_public_path__ + "static/media/hippopotamus.674ca4b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/hippopotamus.svg
// module id = 620
// module chunks = 6